import { Offset, Position } from "devextreme-react/popup";
import PromineoPopover from "components/common/controls/PromineoPopover";
import { useHistory } from "react-router";
import NavItemOption from "interfaces/NavItemOption";

interface Props {
  target: string;
  menuItems: NavItemOption[];
  onSelect?: (item: NavItemOption) => void;
  onClose?: () => void;
  yOffset: number;
}

export default function SubNavMenuePopover(props: Props) {
  const history = useHistory();

  const handleMenuItemClick = (selectedItem: NavItemOption) => {
    if (selectedItem.route) {
      history.push(selectedItem.route);
    }
    props?.onSelect?.(selectedItem);
  };

  const handleSubMenueHiding = () => {
    props.onClose?.();
  };

  const Content = () => {
    return (
      <>
        {(props.menuItems || []).map((item) => {
          return (
            <div
              className="block cursor-pointer py-1 pl-2 pr-16 font-medium hover:bg-promGray3 rounded-sm"
              onClick={() => handleMenuItemClick(item)}
              key={item.itemId}
            >
              {item.text}
            </div>
          );
        })}
      </>
    );
  };

  return (
    <PromineoPopover
      width={"auto"}
      height={"auto"}
      visible={true}
      closeOnOutsideClick={true}
      onHiding={handleSubMenueHiding}
      target={props.target}
    >
      <Position my={{ x: "center", y: "top" }}>
        <Offset y={props.yOffset} x={0} />
      </Position>
      <Content />
    </PromineoPopover>
  );
}
